var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comment-block"},[_c('span',{staticClass:"quote quote-left"},[_c('font-awesome-icon',{attrs:{"icon":"fa-solid fa-quote-left"}})],1),_c('p',[(_vm.comment.image_url)?_c('img',{attrs:{"src":_vm.comment.image_url}}):_vm._e(),_vm._v(" "+_vm._s(_vm.comment.description)+" ")]),_c('span',[_vm._v(_vm._s(_vm.comment.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }